// Общие кирпичики интерфейса для preact-компонентов экранов и окон: кнопка-команда, подсказка, подпись,
// сырой html чужих модулей. Типизированные h()-вызовы (JSX недоступен: тесты запускают .ts напрямую в node).
import { h } from 'preact';
import type { ComponentChildren, JSX } from 'preact';
import { cmdProps } from './commands.ts';
import type { UiCommand } from './commands.ts';

export type V = JSX.Element | null;

/** Готовый html других модулей (лента событий, подсказки с разметкой) внутри компонентов */
export const Raw = ({ tag = 'div', cls, html, id }: { tag?: 'div' | 'span'; cls?: string; html: string; id?: string }): V =>
  h(tag, { ...(cls ? { class: cls } : {}), ...(id ? { id } : {}), dangerouslySetInnerHTML: { __html: html } });

/** Кнопка с командой (data-cmd читает делегат кликов в app.ts) */
export const Btn = ({ cls, id, title, c, disabled, children }: { cls?: string; id?: string; title?: string; c: UiCommand; disabled?: boolean; children?: ComponentChildren }): V =>
  h('button', { ...(cls ? { class: cls } : {}), ...(id ? { id } : {}), ...(title ? { title } : {}), ...cmdProps(c), ...(disabled ? { disabled: true } : {}) }, children);

export const Close = (): V => h('button', { class: 'ghost', ...cmdProps({ k: 'close' }) }, 'Закрыть');
/** Ряд действий внизу окна; Закрыть — всегда последней */
export const Actions = ({ children }: { children?: ComponentChildren }): V => h('div', { class: 'actions' }, children, h(Close, null));

export const Hint = ({ cls = 'hint', children }: { cls?: string; children?: ComponentChildren }): V => h('div', { class: cls }, children);
export const Sub = ({ cls = 'sub', children }: { cls?: string; children?: ComponentChildren }): V => h('div', { class: cls }, children);

/** Класс из необязательных частей: cx('card', sel && 'sel') → "card sel" */
export const cx = (...parts: (string | false | null | undefined)[]): string => parts.filter(Boolean).join(' ');
